import { Controller } from "@hotwired/stimulus"

// Assistenten-programma periode/activiteiten-modal. Volgt het bewezen
// activity-picker-patroon: de turbo-frame ZELF is de modal (de server rendert de
// overlay-shell erin). Openen = de "Nieuwe periode"/bewerk-link navigeert de
// frame; sluiten = de frame leegmaken. Géén persistente verborgen div met een
// connect-reset die de modal bij elke Stimulus-reconnect dicht-klapte (de oude
// bug: popup verdween zodra de pagina re-renderde).
export default class extends Controller {
  close() {
    const frame = document.getElementById("ap_modal_frame")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }

  // Backdrop-klik sluit alleen een ONGEWIJZIGDE modal. Zodra de planner iets
  // heeft ingevuld blijft het formulier staan (test-day brief 2026-06-11:
  // "clicking the backdrop no longer dismisses your half-filled form").
  // Sluiten kan dan nog via Escape of de kruis-knop — beide expliciet.
  closeBackground(event) {
    if (event.target !== event.currentTarget) return
    if (this.#formDirty()) return
    this.close()
  }

  #formDirty() {
    const form = this.element.querySelector("form")
    if (!form) return false
    return Array.from(form.elements).some((el) => {
      if (["hidden", "submit", "button"].includes(el.type)) return false
      if (el.type === "checkbox" || el.type === "radio") return el.checked !== el.defaultChecked
      if (el.tagName === "SELECT") {
        if (el.multiple) return Array.from(el.options).some((o) => o.selected !== o.defaultSelected)
        // Zonder expliciet `selected`-attribuut kiest de browser optie 0 maar
        // blijft defaultSelected overal false — vergelijk daarom met de
        // effectieve default (eerste defaultSelected, anders index 0).
        const defaultIndex = Array.from(el.options).findIndex((o) => o.defaultSelected)
        return el.selectedIndex !== (defaultIndex === -1 ? 0 : defaultIndex)
      }
      return el.value !== el.defaultValue
    })
  }

  stop(event) {
    event.stopPropagation()
  }

  // Enter in het specialisme-datalist-veld bevestigde de suggestie ÉN submitte
  // meteen het hele formulier → de modal "knalde weg" (upsert leegt de frame).
  // We onderdrukken de submit op Enter zodat de planner eerst alle velden invult
  // en bewust op Opslaan klikt. De getypte/gekozen datalist-waarde blijft staan.
  stopEnter(event) {
    event.preventDefault()
  }
}
